// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2meIz","placeholdersHeader":"styles_placeholdersHeader__-oqkH","editorStyle":"styles_editorStyle__3Fbtj","placeholdersBox":"styles_placeholdersBox__ZJwTO"};